/** @jsx jsx */
import PropTypes from 'prop-types'
import { Heading, jsx } from 'theme-ui'
import { useTranslate } from '@arfabrands/gatsby-theme-assembly'

const Author = ({ name }) => {
  const translate = useTranslate()

  return (
    <Heading
      as="h3"
      sx={{
        color: '#851B54',
        fontFamily: 'GT Walsheim Regular,Helvetica,Arial,Sans-Serif',
        fontSize: ['24px', '24px', '34px'],
        fontWeight: 'normal',
        width: '100%',
        padding: ['1rem 0'],
        textAlign: 'left'
      }}
    >
      {translate('articles.author_by')} {name}
    </Heading>
  )
}

Author.propTypes = {
  name: PropTypes.string
}

export default Author
